import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthPayloadTicket, AuthorizationData, TransactionAuthorizationResult } from '@zero/shared/util-models';
import { Checklist } from '../../entities/checklist.entity';

export const terminateDepotActions = createActionGroup({
  source: 'Terminate Depot',
  events: {
    'load checklist state': emptyProps(),
    terminate: props<{ reason: string }>(),
    'set data to authorize': props<{ dataToAuthorize: AuthorizationData<AuthPayloadTicket> }>(),
    'handle authentication result': props<{ result: TransactionAuthorizationResult }>(),
    'check status': emptyProps(),
    'set error': props<{ error: boolean }>(),
  },
});

export const terminateDepotApiActions = createActionGroup({
  source: 'Terminate Depot API',
  events: {
    'load checklist state success': props<{ checklist: Checklist }>(),
    'load checklist state failure': props<{ error: HttpErrorResponse }>(),
    'terminated success': props<{ terminationDone: boolean }>(),
    'terminated failure': props<{ error: HttpErrorResponse }>(),
  },
});
